export default "__VITE_ASSET__4OWw3F0H__"